module.exports = __webpack_public_path__ + "img/antibody.88f0cfaf.svg";